import { render } from "./BandeauPatient.vue?vue&type=template&id=77407b8c&scoped=true"
import script from "./BandeauPatient.vue?vue&type=script&lang=js"
export * from "./BandeauPatient.vue?vue&type=script&lang=js"

import "./BandeauPatient.vue?vue&type=style&index=0&id=77407b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77407b8c"]])

export default __exports__